import { memo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-16-refresh.tsx
/**
* icon.16.refresh
*
* Keywords: circular, clockwise, rotation, arrows, cycle, loop, reload, sync
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik0xMi41IDN2Mi41SDEwbS00IDVIMy41VjEzIi8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOCAzLjVhNC41IDQuNSAwIDAgMC00LjQ3MyA0Yy0uMDMuMjc1LS4yNS41LS41MjcuNWEuNDY3LjQ2NyAwIDAgMS0uNDc4LS41IDUuNSA1LjUgMCAwIDEgOS43NTgtMi45NTQuNDY3LjQ2NyAwIDAgMS0uMTIuNjhjLS4yMy4xNTQtLjUzOC4wOS0uNzE1LS4xMjJBNC40OSA0LjQ5IDAgMCAwIDggMy41bS00LjE2IDcuMjc0YS40NjcuNDY3IDAgMCAwLS4xMi42OEE1LjUgNS41IDAgMCAwIDEzLjQ3OCA4LjUuNDY3LjQ2NyAwIDAgMCAxMyA4Yy0uMjc2IDAtLjQ5Ny4yMjUtLjUyNy41YTQuNSA0LjUgMCAwIDEtNy45MTggMi4zOTZjLS4xNzctLjIxMi0uNDg2LS4yNzYtLjcxNS0uMTIzIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-12972
*/
const Icon16Refresh = memo(function Icon16Refresh(props) {
	return /* @__PURE__ */ jsxs("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: [/* @__PURE__ */ jsx("path", {
			stroke: "var(--fpl-icon-color, var(--color-icon))",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M12.5 3v2.5H10m-4 5H3.5V13"
		}), /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M8 3.5a4.5 4.5 0 0 0-4.473 4c-.03.275-.25.5-.527.5a.467.467 0 0 1-.478-.5 5.5 5.5 0 0 1 9.758-2.954.467.467 0 0 1-.12.68c-.23.154-.538.09-.715-.122A4.49 4.49 0 0 0 8 3.5m-4.16 7.274a.467.467 0 0 0-.12.68A5.5 5.5 0 0 0 13.478 8.5.467.467 0 0 0 13 8c-.276 0-.497.225-.527.5a4.5 4.5 0 0 1-7.918 2.396c-.177-.212-.486-.276-.715-.123",
			clipRule: "evenodd"
		})]
	});
});
//#endregion
export { Icon16Refresh };

//# sourceMappingURL=icon-16-refresh.js.map